import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import $ from 'jquery';

$(function () {
    UIkit.use(Icons);
    let slider = $('.featured-stories-slider .slider');

    if (slider.length > 0) {
        UIkit.slider(slider, {
            draggable: false,
        });
    }
});